import { HttpClient } from '@angular/common/http';
import { Component, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../services/auth.service';
import { LoginInformationModel } from '../login-information.model';
import AudioHelper from '../../../../audio/helpers/audio.helper';

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
})
export class LoginFormComponent {

  public loginInformation: LoginInformationModel = new LoginInformationModel(null, null, false);
  public submitted: boolean = false;
  public error: { message: string } = {message: null};

  protected audioHelper: AudioHelper;

  /**
   * The constructor.
   * @param http HttpClient
   * @param route ActivatedRoute
   * @param router Router
   * @param authService AuthService
   * @param injector
   */
  public constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private injector: Injector,
  ) {
    this.audioHelper = injector.get(AudioHelper);
  }

  /**
   * Submit the login form
   *
   * @return void
   */
  public onSubmit(): void {

    this.submitted = true;
    this.authService.doFormLogin(
      this.loginInformation.username,
      this.loginInformation.password,
      this.loginInformation.remember,
    ).subscribe({
      error: (error) => {
        this.audioHelper.playAudio('error');
        if (error.error.error === 'invalid_request' || error.error.error === 'invalid_credentials') {
          this.error.message = error.error.message;
        }
      },
    });
  }
}
